// Mobile initialization and Capacitor plugins setup
import { App } from '@capacitor/app';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

export const initializeMobileApp = async () => {
  if (Capacitor.isNativePlatform()) {
    console.log('🚀 Initializing mobile app...');

    // Configure status bar
    try {
      await StatusBar.setStyle({ style: Style.Default });
      await StatusBar.setBackgroundColor({ color: '#ffffff' });
      console.log('✅ Status bar configured');
    } catch (error) {
      console.warn('⚠️ Status bar configuration failed:', error);
    }

    // Hide splash screen after app is loaded
    try {
      await SplashScreen.hide();
      console.log('✅ Splash screen hidden');
    } catch (error) {
      console.warn('⚠️ Splash screen hide failed:', error);
    }

    // App state change listeners
    App.addListener('appStateChange', ({ isActive }) => {
      console.log('📱 App state changed. Is active:', isActive);
      if (isActive) {
        // App became active - good place to refresh data if needed
        console.log('🔄 App became active - could refresh medical data');
      }
    });

    // Back button handler for Android
    App.addListener('backButton', ({ canGoBack }) => {
      if (!canGoBack) {
        // At the root page, minimize the app instead of closing
        App.minimizeApp();
      } else {
        // Let the default back navigation happen
        window.history.back();
      }
    });

    console.log('✅ Mobile app initialization complete');
  } else {
    console.log('🌐 Running in web mode');
  }
};

// Utility function to check if running on mobile
export const isMobile = () => Capacitor.isNativePlatform();

// Platform detection
export const getPlatform = () => Capacitor.getPlatform();